import { memo } from 'react';

import AutomaticIconSVG from '@/assets/automatic-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAutomaticIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AutomaticIconSVG} {...props} />;

export const AutomaticIcon = memo(IAutomaticIcon) as typeof IAutomaticIcon;
